import React, { useEffect, useRef } from "react";
import ThemeSelector from "./ThemeSelector";

function initialsFor(value) {
  const parts = String(value || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "HC";
  return parts.slice(0, 2).map((part) => part[0]).join("").toUpperCase();
}

export default function StudioProfileMenu({
  user,
  displayName,
  profileInitials,
  roleLabel,
  completionLabel,
  onEditProfile,
  onSignOut,
}) {
  const menuRef = useRef(null);
  useEffect(() => {
    const closeOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) menuRef.current.open = false;
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape" && menuRef.current?.open) {
        menuRef.current.open = false;
        menuRef.current.querySelector("summary")?.focus();
      }
    };
    document.addEventListener("pointerdown", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  const runAction = (action) => {
    if (menuRef.current) menuRef.current.open = false;
    if (action) action();
  };

  const name = displayName || user?.display_name || user?.username || "Studio user";
  const role = roleLabel || (user?.roles || []).map((item) => String(item).replaceAll("_", " ")).join(" · ") || "Authenticated";
  return (
    <details className="studio-profile-menu" ref={menuRef}>
      <summary className="studio-profile-menu-trigger" aria-label="Open profile and appearance menu">
        <span className="studio-profile-menu-avatar" aria-hidden="true">{profileInitials || initialsFor(name)}</span>
        <span className="studio-profile-menu-identity">
          <strong>{name}</strong>
          <small>{role}</small>
        </span>
      </summary>
      <div className="studio-profile-menu-panel">
        {completionLabel && <p className="studio-profile-menu-completion">{completionLabel}</p>}
        <div className="studio-profile-menu-appearance">
          <span>Appearance</span>
          <ThemeSelector compact />
        </div>
        {onEditProfile && <button type="button" className="studio-profile-menu-action" onClick={() => runAction(onEditProfile)}>Edit profile</button>}
        {onSignOut && <button type="button" className="studio-profile-menu-action studio-profile-menu-signout" onClick={() => runAction(onSignOut)}>Sign out</button>}
      </div>
    </details>
  );
}
